<template>
  <div id="app">
 <!-- 该组件会根据不同的访问路径，渲染不同的组件 -->
      <router-view></router-view>
  </div>
</template>

<script>
// import LoadPhoneapp from "./view/LoadPhoneapp";
export default {
  components: {
  //  LoadPhoneapp,
  },
};
</script>

<style>
</style>
